import { RequiredTranslationsTemplate } from '.'

const pt: RequiredTranslationsTemplate = {
  meta: {
    localeName: 'Português',
  },
  home: {
    title: 'RECALL DE PRODUTO - ROCKRIDER XC500S',
    description:
      'Muito obrigado por adquirir a bicicleta mountain bike (MTB) ROCKRIDER XC500S. Nós identificamos uma fragilidade potencial no garfo. Apenas algumas bicicletas possuem este defeito, por isso, por favor, preencha abaixo o número de rastreabilidade da sua bicicleta, composto por 30 dígitos, localizado na parte inferior do quadro, para confirmar se sua bicicleta é impactada por este Recall.',
    form: {
      title: 'Por favor entre as informações abaixo: ',
      fields: {
        serialNumber: 'Número de Rastreabilidade',
        serialNumberFamily: 'N° série (début)',
        firstName: 'Primeiro Nome',
        lastName: 'Sobrenome',
        email: 'Email',
        phone: 'Telefone',
        country: 'País',
        submit: 'Validar',
        choose: 'Escolha...',
      },
      errors: {
        requiredField: 'Este campo é obrigatório',
        unknownSerialNumber: 'Número de série desconhecido',
        provide6Numbers: 'Por favor note que são necessários 6 dígitos',
      },
      confirmations: {
        good: {
          title: 'A sua bicicleta não é afectada',
          p1: 'Por favor, note que sua bicicleta não está impactada por este Recall. Você pode desfrutar e continuar utilizando normalmente sua bicicleta.',
          p2: 'Pedimos desculpa por qualquer inconveniente causado,',
          p3: 'Muito obrigado,',
          p4: 'Decathlon Brasil',
        },
        defective: {
          title: 'Infelizmente sua bicicleta está afetada por este defeito.',
          p1: 'Pedimos por favor que pare de utilizar esta bicicleta imediatamente e procure uma de nossas lojas, mais próxima de você, para que possamos reparar este problema.',
          p2: 'Note que talvez seja necessário retermos sua bicicleta por alguns dias para o processo de reparo. Tenha certeza de que faremos o possível para que seja o mais rápido possível. Pedimos que entre em contato diretamente com a loja mais próxima a você para ter um prazo estimativo.',
          p3: 'Acesse este link para verificar todas as nossas lojas espalhas, e encontrar a mais próxima a você:',
          decathlonLocatorLink: 'https://www.decathlon.com.br/lojas/',
          p4: 'Clique no icone abaixo para baixar o documento “Notificação de Retorno do Cliente”, este que você deve apresentar na loja de sua escolha.',
          p5: 'Para mais informações, entre em contato com nossa equipe de atendimento pelo telefone (11) 3003-1414 (Atendimento de segunda à sábado e feriado) ou por e-mail no endereço https://www.decathlon.com.br/atendimento',
        },
      },
    },
    findTheSerialNumber: {
      title: 'Como encontrar o número de rastreabilidade da sua bicicleta',
      description:
        'O número composto por 30 digitos está impresso na parte inferior do quadro de sua bicicleta, próximo ao movimento central. Veja a imagem abaixo: ',
    },
  },
}

export default pt
